import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Header } from './components/layout';
import { Home } from './pages';
import { 
  Demo, 
  Report, 
  SampleReports, 
  FAQ, 
  TrustCentre, 
  RSNA2025, 
  ROICalculator 
} from './pages';
import { useMediaQuery } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

function App() {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Router>
      <div>
        <Header isMobile={isMobile} />
        <Routes>
          <Route path="/" element={<Home isMobile={isMobile} theme={theme}/>} />
          <Route path="/demo" element={<Demo isMobile={isMobile} theme={theme}/>} />
          <Route path="/reports" element={<SampleReports isMobile={isMobile} theme={theme}/>} />
          <Route path="/report/:reportId" element={<Report />} />
          <Route path="/faq" element={<FAQ isMobile={isMobile} theme={theme}/>} />
          <Route path="/trust-centre" element={<TrustCentre isMobile={isMobile} theme={theme}/>} />
          <Route path="/rsna-2025" element={<RSNA2025 isMobile={isMobile} theme={theme}/>} />
          <Route path="/roi-calculator" element={<ROICalculator isMobile={isMobile} theme={theme} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
